export const giftMenuLinks = [
  {
    label: 'Pasta academy vouchers',
    path: 'https://pastaevangelists.com/collections/pasta-academy-gift-vouchers',
  },
  {
    label: 'Gift vouchers',
    path: 'https://pastaevangelists.com/pages/gift-cards',
  },
  {
    label: 'Gift boxes',
    path: 'https://pastaevangelists.com/collections/gift-boxes',
  },
  {
    label: 'Gift subscriptions',
    path: 'https://pastaevangelists.com/collections/fresh-pasta-gift-plans',
  },
  {
    label: 'Pasta making kits',
    path: 'https://pastaevangelists.com/collections/pasta-making-kits',
  },
  {
    label: 'Atavi',
    path: 'https://pastaevangelists.com/collections/atavi',
  },
  {
    label: 'Truffle emporium',
    path: 'https://pastaevangelists.com/collections/new-the-truffle-collection',
  },
];

export const experienceLinks = [
  {
    label: 'Pasta academy',
    name: 'events-themes',
  },
  {
    label: 'Private Events - Book Your Own',
    name: 'private-events-themes',
  },
  {
    label: 'Private Events - Enquiries',
    path: 'https://pastaevangelists.com/pages/team-events',
  },
  {
    label: 'Christmas 2025',
    path: 'https://pastaevangelists.com/pages/christmas-2025',
  },
  {
    label: 'Event FAQs',
    path: 'https://pastaevangelists.com/pages/pasta-academy',
  },
];

export const guideLinks = [
  {
    label: 'Blog',
    path: 'https://pastaevangelists.com/blogs/blog',
  },
  {
    label: 'Italian cuisine',
    path: 'https://pastaevangelists.com/pages/italian-kitchen-hub',
  },
  {
    label: 'Pasta types & sauces',
    path: 'https://pastaevangelists.com/pages/types-of-pasta',
  },
  {
    label: 'Wine pairing wheel',
    path: 'https://pastaevangelists.com/pages/pasta-wine-pairing-guide',
  },
  {
    label: 'YouTube channel',
    path: 'https://www.youtube.com/channel/UCpvBXtywbSufwz9EyXqNBhQ',
  },
];

export const storesLinks = [
  {
    label: 'Chiswick',
    name: 'restaurant-details',
    params: {
      restaurantId: '16',
    },
  },
  {
    label: 'Farringdon',
    name: 'restaurant-details',
    params: {
      restaurantId: '19',
    },
  },
  {
    label: 'Greenwich',
    name: 'restaurant-details',
    params: {
      restaurantId: '98',
    },
  },
  {
    label: 'Guildford',
    name: 'restaurant-details',
    params: {
      restaurantId: '46',
    },
  },
  {
    label: 'Harrods',
    path: 'https://pastaevangelists.com/pages/visit-us',
  },
  {
    label: 'York (Indigo Hotel)',
    name: 'restaurant-details',
    params: {
      restaurantId: '109',
    },
  },
  {
    label: 'Manchester Airport',
    name: 'restaurant-details',
    params: {
      restaurantId: '145',
    },
  },
  {
    label: 'New Oxford Street',
    name: 'restaurant-details',
    params: {
      restaurantId: '185',
    },
  },
  {
    label: 'Richmond',
    name: 'restaurant-details',
    params: {
      restaurantId: '106',
    },
  },
];
